/* INVESTMENT_LEAD - This line cannot be edited or removed */
export const GET_ALL_INVESTMENT_LEADS = "GET_ALL_INVESTMENT_LEADS"
export const GET_ALL_INVESTMENT_LEADS_SUCCESS =
  "GET_ALL_INVESTMENT_LEADS_SUCCESS"
export const GET_ALL_INVESTMENT_LEADS_FAIL = "GET_ALL_INVESTMENT_LEADS_FAIL"

/* INVESTMENT_LEAD DETAILS */
export const GET_INVESTMENT_LEAD_DETAILS = "GET_INVESTMENT_LEAD_DETAILS"
export const GET_INVESTMENT_LEAD_DETAILS_SUCCESS =
  "GET_INVESTMENT_LEAD_DETAILS_SUCCESS"
export const GET_INVESTMENT_LEAD_DETAILS_FAIL =
  "GET_INVESTMENT_LEAD_DETAILS_FAIL"

/* CREATE INVESTMENT_LEAD */
export const CREATE_INVESTMENT_LEAD = "CREATE_INVESTMENT_LEAD"
export const CREATE_INVESTMENT_LEAD_SUCCESS = "CREATE_INVESTMENT_LEAD_SUCCESS"
export const CREATE_INVESTMENT_LEAD_FAIL = "CREATE_INVESTMENT_LEAD_FAIL"

/* Edit INVESTMENT_LEAD */
export const UPDATE_INVESTMENT_LEAD = "UPDATE_INVESTMENT_LEAD"
export const UPDATE_INVESTMENT_LEAD_SUCCESS = "UPDATE_INVESTMENT_LEAD_SUCCESS"
export const UPDATE_INVESTMENT_LEAD_FAIL = "UPDATE_INVESTMENT_LEAD_FAIL"

/* Delete INVESTMENT_LEAD */
export const DELETE_INVESTMENT_LEAD = "DELETE_INVESTMENT_LEAD"
export const DELETE_INVESTMENT_LEAD_SUCCESS = "DELETE_INVESTMENT_LEAD_SUCCESS"
export const DELETE_INVESTMENT_LEAD_FAIL = "DELETE_INVESTMENT_LEAD_FAIL"
